/**
 * Frontend module for handling messaging functionality in the Thunderstorm framework.
 * Provides message creation and management capabilities.
 */
import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_message, MessageType_Text } from '@nu-art/ts-messaging-shared';
/**
 * Dispatcher instance for handling message updates
 */
export const dispatch_onMessagesUpdated = new ThunderDispatcherV3('__onMessagesUpdated');
/**
 * Frontend module class for handling messages
 * Extends the base API module with message-specific functionality
 */
export class ModuleFE_Message_Class extends ModuleFE_BaseApi {
    /**
     * Initializes the message module with message definition and dispatcher
     */
    constructor() {
        super(DBDef_message, dispatch_onMessagesUpdated);
    }
    /**
     * Creates a new text message in the specified topic
     *
     * @param topicId - The ID of the topic to create the message in
     * @param msg - The text content of the message
     * @returns Promise that resolves when message is created
     */
    async createMessage(topicId, msg) {
        const newMessage = { type: MessageType_Text, topicId, text: msg };
        await this.v1.upsert(newMessage).executeSync();
    }
}
/**
 * Singleton instance of the frontend message module
 */
export const ModuleFE_Message = new ModuleFE_Message_Class();
//# sourceMappingURL=ModuleFE_Message.js.map